<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m11 17-5-5m0 0 5-5m-5 5h12"
      />
    </svg>
  </span>
</template>
